import { useEffect, useState } from 'react'

interface WechatAuthOptions {
  appId?: string
}

const useWechatAuth = (options: WechatAuthOptions = {}) => {
  const [wxCode, setWxCode] = useState<string | null>(null)
  const [wxAuthLoading, setWxAuthLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!options.appId || options.appId === '') {
      setWxAuthLoading(false)
      return
    }
    checkWechatAuth()
  }, [])

  const checkWechatAuth = () => {
    const isWeChat = /MicroMessenger/i.test(navigator.userAgent)

    if (!isWeChat) {
      setWxAuthLoading(false)
      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const wxCode = urlParams.get('code')

    if (!wxCode) {
      const appId = options.appId
      const redirectUri = encodeURIComponent(window.location.href)
      const scope = 'snsapi_base'
      const state = 'STATE'

      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    } else {
      setWxCode(wxCode)
      setWxAuthLoading(false)
    }
  }

  return { wxCode, wxAuthLoading }
}

export default useWechatAuth
